// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2sCgV","dark":"Button_dark__18FFt","minimal":"Button_minimal__1mafH","icon":"Button_icon__hOypT"};